import { computed } from 'vue';
import { useStore } from 'vuex';

// The account's agents as { id, name, thumbnail }, fetched once if the store doesn't have them yet
export function useAgents() {
  const store = useStore();
  const agents = computed(() => store.getters['agents/getAgents'] || []);
  if (!agents.value.length) store.dispatch('agents/get');

  return computed(() =>
    agents.value.map(agent => ({
      id: agent.id,
      name: agent.available_name || agent.name,
      thumbnail: agent.thumbnail,
      availability: agent.availability_status,
    }))
  );
}
